export function initContactNav() {
  const navContact = document.getElementById("mb-nav-contact");
  const navContactIcon = document.querySelector("#mb-nav-contact > svg");

  if (navContactIcon) {
    let navContaxctTimer;
    navContactIcon.addEventListener("click", () => {
      navContact.classList.toggle("open");

      // auto hide navi after 5seconds
      clearInterval(navContaxctTimer);
      navContaxctTimer = setInterval(function () {
        navContact.classList.remove("open");
        clearInterval(navContaxctTimer);
      }, 5000);
    });
  }
}
